import { render, staticRenderFns } from "./EditorElementInfoEventsAddAction.vue?vue&type=template&id=6a3d25e1&lang=pug"
import script from "./EditorElementInfoEventsAddAction.vue?vue&type=script&lang=js"
export * from "./EditorElementInfoEventsAddAction.vue?vue&type=script&lang=js"
import style0 from "./EditorElementInfoEventsAddAction.vue?vue&type=style&index=0&id=6a3d25e1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports